import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import Link from 'components/Link'

import styles from './styles.css'

class LinkNav extends Component {
  static propTypes = {
    className: PropTypes.string,
    links: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string.isRequired,
        href: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
          .isRequired,
      }),
    ).isRequired,
  }

  static defaultProps = {
    className: '',
  }

  getClassName() {
    return classnames(styles.root, this.props.className)
  }

  render() {
    return (
      <nav className={this.getClassName()}>
        <ul className={styles.list}>
          {this.props.links.map(link => (
            <li key={link.label} className={styles.bullet}>
              <Link {...link} className={styles.link} />
            </li>
          ))}
        </ul>
      </nav>
    )
  }
}

export default LinkNav



// WEBPACK FOOTER //
// ../source/components/LinkNav/index.js